import React, { useRef, useState } from 'react';
import { FaPlus, FaBars, FaTimes } from 'react-icons/fa';
import './sidebar.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { Link } from "react-router-dom";
import { Toast } from 'primereact/toast';

const Sidebar = ({ setIsNewChat }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toast = useRef(null);

  const show = () => {
    toast.current.show({ severity: 'info', summary: 'New Chat', detail: 'Ask a new question' });
  };

  const navigate = useNavigate();
  const location = useLocation();

  const handleNewChat = () => {
    if (location.pathname !== "/chatbot") {
      // Navigate to chatbot page if not already there
      navigate("/chatbot");
    } else {
      // Clear chat history (assuming setIsNewChat is passed as a prop)
      setIsNewChat(true);
    }
  };

  const handleStepClick = (step) => {
    navigate(`/steps/${step}`);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <>
      <button className="menu-toggle" onClick={toggleSidebar}>
        {isSidebarOpen ? <FaTimes /> : <FaBars />}
      </button>

      <div
        className={`sidebar-overlay ${isSidebarOpen ? 'active' : ''}`}
        onClick={closeSidebar}
      />

      <div className={`sidebar ${isSidebarOpen ? 'active' : ''}`}>
        <div className="sidebar-header">
          <h1><Link to={'/'}> BUSINESS GUIDE</Link></h1>
          <p>All in one business solution</p>
          <Toast ref={toast} />
          <button className="new-chat" onClick={() => { handleNewChat(); show(); }}>
            <FaPlus /> New Chat
          </button>
        </div>
        <div className="folders">
          <h3>STEPS</h3>
          <ul>
            <li
              className={location.pathname === '/steps/step1' ? 'active' : ''}
              onClick={() => handleStepClick('step1')}
            >
              1 - Register your business
            </li>

            <li
              className={location.pathname === '/steps/step2' ? 'active' : ''}
              onClick={() => handleStepClick('step2')}
            >
              2 - Tax Registration and Licenses
            </li>

            <li
              className={location.pathname === '/steps/step3' ? 'active' : ''}
              onClick={() => handleStepClick('step3')}
            >
              3 - Business Bank Account and Finances
            </li>

            <li
              className={location.pathname === '/steps/step4' ? 'active' : ''}
              onClick={() => handleStepClick('step4')}
            >
              4 - Business Location and Start Operations
            </li>

            <li
              className={location.pathname === '/steps/step5' ? 'active' : ''}
              onClick={() => handleStepClick('step5')}
            >
              5 - Ongoing Legal and Tax Obligations
            </li>
            <li
              className={location.pathname === '/templates' ? 'active' : ''}
              onClick={() => navigate('/templates')}
            >
              Business Templates
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;